/*
 * @copyright 2026 Fortee Custom Apparel Inc. All rights reserved.
 * @license PROPRIETARY - Unauthorized copying, modification, or distribution
 *          of this file is strictly prohibited.
 *
 * fortee-bundle-landing.js
 * Shared vanilla-JS behaviors for the Fortee bundle landing sections.
 *
 * Behaviors:
 *  - Gallery thumb swap (.flb-thumb click → swap .flb-gallery-main bg)
 *  - Tab switching (.flb-tabs delegated — works for spotlight + comparison tabs)
 *  - FAQ accordion (.flb-faq-item — single-open or multi-open based on data attr)
 *  - "Customize now" CTA opens the #fortee-bundle-builder full-screen overlay
 *  - Floating CTA visibility — hidden when hero CTA or page-bottom is in view
 *  - Announcement bar marquee — pauses on hover for accessibility
 *
 * No external dependencies. Single global IIFE.
 */
/* ​‌​​​‌‌​‍​‌​​‌‌‌‌‍​‌​‌​​‌​‍​‌​‌​‌​​‍​‌​​​‌​‌‍​‌​​​‌​‌‍​​‌​‌‌​‌‍​​‌‌​​‌​‍​​‌‌​​​​‍​​‌‌​​‌​‍​​‌‌​‌‌​‍​​‌​‌‌​‌‍​‌​‌​‌‌​‍​​‌‌​​‌​‍​​‌​‌‌​‌‍​‌​​​​‌​‍​‌​​‌‌​​‍​‌​​​‌​​‍​‌​​‌​‌‌‍​‌​​​‌​‌‍​‌​‌‌​​‌‍​​‌​‌‌​‌‍​​‌‌​​​‌‍​‌‌​​‌​‌‍​​‌‌​‌​​‍​​‌‌​​‌‌‍​​‌‌​‌​​‍​‌‌​​​​‌‍​‌‌​​‌​‌‍​‌‌​​​‌‌‍​​‌‌​​​​‍​​‌‌​​​‌‍​​‌‌​​​‌‍​‌‌​​​‌​ */
(function () {
  'use strict';

  if (window.__forteeBundleLandingInit) return;
  window.__forteeBundleLandingInit = true;

  /* ------------------------------------------------------------------ */
  /* Gallery thumb swap                                                 */
  /* Each gallery: .flb-gallery > .flb-thumbs > .flb-thumb[data-flb-img]*/
  /*                            + .flb-gallery-main                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.flb-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.flb-gallery');
    if (!gallery) return;
    var url = thumb.getAttribute('data-flb-img');
    if (!url) return;

    var main = gallery.querySelector('.flb-gallery-main');
    if (main) main.style.backgroundImage = 'url(' + url + ')';

    var siblings = gallery.querySelectorAll('.flb-thumb');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.toggle('is-active', siblings[i] === thumb);
    }
  });

  /* ------------------------------------------------------------------ */
  /* Tab switching — generic delegation                                 */
  /* Container: .flb-tabs[data-flb-tabs]                                */
  /* Heads:     .flb-tab-btn[data-flb-tab="key"]                        */
  /* Panels:    .flb-tab-panel[data-flb-tab="key"]                      */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.flb-tab-btn');
    if (!btn) return;
    var container = btn.closest('[data-flb-tabs]');
    if (!container) return;
    var key = btn.getAttribute('data-flb-tab');
    if (!key) return;

    var btns = container.querySelectorAll('.flb-tab-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', btns[i].getAttribute('data-flb-tab') === key);
      btns[i].setAttribute('aria-selected', btns[i] === btn ? 'true' : 'false');
    }
    var panels = container.querySelectorAll('.flb-tab-panel');
    for (var j = 0; j < panels.length; j++) {
      var match = panels[j].getAttribute('data-flb-tab') === key;
      panels[j].classList.toggle('is-active', match);
      panels[j].setAttribute('aria-hidden', match ? 'false' : 'true');
    }
  });

  /* ------------------------------------------------------------------ */
  /* FAQ accordion (CSS-only fallback uses native <details>; this adds  */
  /* a smooth max-height transition + single-open mode when             */
  /* data-flb-faq-mode="single" on the .flb-faq grid container).        */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.flb-faq-q');
    if (!summary) return;
    var item = summary.closest('.flb-faq-item');
    if (!item) return;
    e.preventDefault();
    var isOpen = item.classList.contains('is-open');
    var grid = item.closest('.flb-faq-grid');
    if (grid && grid.getAttribute('data-flb-faq-mode') === 'single' && !isOpen) {
      var siblings = grid.querySelectorAll('.flb-faq-item.is-open');
      for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-open');
    }
    item.classList.toggle('is-open', !isOpen);
    summary.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ------------------------------------------------------------------ */
  /* "Customize now" — open the builder as a full-screen overlay        */
  /* Any anchor with data-flb-cta-customize OR href="#fortee-bundle-    */
  /* builder" opens the builder overlay instead of jumping/scrolling.   */
  /* The builder section listens for 'fortee-customize-now' and takes   */
  /* over the page so the customer can't scroll back into the marketing */
  /* content mid-configuration.                                         */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-flb-cta-customize], a[href="#fortee-bundle-builder"]');
    if (!a) return;
    // Only intercept if the builder actually exists on this page.
    if (!document.getElementById('fortee-bundle-builder')) return;
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('fortee-customize-now'));
  });

  /* ------------------------------------------------------------------ */
  /* Floating CTA visibility                                            */
  /* Hide when hero primary CTA OR the bundle builder section is in     */
  /* view (so we don't double-up). Uses IntersectionObserver with a     */
  /* small viewport margin.                                             */
  /* ------------------------------------------------------------------ */
  function initFloatingCta() {
    var floating = document.querySelector('.flb-floating-cta');
    if (!floating) return;
    if (!('IntersectionObserver' in window)) return;

    var hideTargets = [];
    var hero = document.querySelector('[data-flb-floating-hide]');
    if (hero) hideTargets.push(hero);
    var builder = document.getElementById('fortee-bundle-builder');
    if (builder) hideTargets.push(builder);

    if (hideTargets.length === 0) return;

    var visibleSet = new Set();
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var ent = entries[i];
        if (ent.isIntersecting) visibleSet.add(ent.target);
        else visibleSet.delete(ent.target);
      }
      floating.classList.toggle('flb-floating-cta--hidden', visibleSet.size > 0);
    }, { threshold: 0.05 });

    for (var k = 0; k < hideTargets.length; k++) observer.observe(hideTargets[k]);
  }

  /* ------------------------------------------------------------------ */
  /* Mobile reviews relocation                                          */
  /* On viewports ≤1000px, move the fortee-bundle-reviews <section>     */
  /* into the placeholder slot inside the hero so the customer sees:    */
  /*   image → thumbs → REVIEWS → feature pills → title → price → CTA   */
  /* Restored to its original sibling position above 1000px.            */
  /* ------------------------------------------------------------------ */
  function initMobileReviewsRelocate() {
    var slot = document.querySelector('[data-flb-mobile-reviews-slot]');
    if (!slot) return;
    var reviews = document.querySelector('section[id*="fortee-bundle-reviews"]');
    if (!reviews) return;

    var originalParent = reviews.parentNode;
    var originalNext = reviews.nextElementSibling;
    var mql = window.matchMedia('(max-width: 1000px)');

    function reposition() {
      if (mql.matches) {
        if (reviews.parentNode !== slot) slot.appendChild(reviews);
      } else if (reviews.parentNode === slot && originalParent) {
        if (originalNext && originalNext.parentNode === originalParent) {
          originalParent.insertBefore(reviews, originalNext);
        } else {
          originalParent.appendChild(reviews);
        }
      }
    }

    reposition();
    if (mql.addEventListener) mql.addEventListener('change', reposition);
    else if (mql.addListener) mql.addListener(reposition);
  }

  /* ------------------------------------------------------------------ */
  /* Announcement bar marquee — pause on hover (accessibility).         */
  /* Uses CSS animation; JS just toggles a paused class.                */
  /* ------------------------------------------------------------------ */
  function initAnnouncementBar() {
    var bars = document.querySelectorAll('.flb-announce');
    for (var i = 0; i < bars.length; i++) {
      (function (bar) {
        bar.addEventListener('mouseenter', function () { bar.classList.add('is-paused'); });
        bar.addEventListener('mouseleave', function () { bar.classList.remove('is-paused'); });
      })(bars[i]);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Init on DOM ready                                                  */
  /* ------------------------------------------------------------------ */
  function init() {
    initFloatingCta();
    initAnnouncementBar();
    initMobileReviewsRelocate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
